import { Component, OnInit } from '@angular/core';
import { FirebaseService } from 'src/app/service/firebase.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalEmailComponent } from '../modals/modal-email/modal-email.component';
import { hexToRgb } from '@swimlane/ngx-charts';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  login: string = "";
  password: string = "";
  private dialogRef: MatDialogRef<any>;
  constructor(private firebaseService: FirebaseService, private snackBar: MatSnackBar, private dialog: MatDialog) { }
  window: any;
  ngOnInit() {
    this.window = window;
   // console.log(this.window.location.href, this.window.location.href.includes('digitalbroker'))
  }

  /**
   * Login to firebase authentification system
   * */
  log() {
    this.firebaseService.logIn(this.login, this.password).then((data) => {

    }).catch((err) => {
      this.snackBar.open(err.message, 'OK', {
        duration: 5000
      })
      })
  }

  triggerResetPassword() {
    this.dialogRef = this.dialog.open(ModalEmailComponent, {

      width: "25vw",

    });

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log(result)

        this.firebaseService.resetPasswordSendEmail(result).then(d => {
          console.log(d)
          this.snackBar.open('Un email a été envoyé.', 'OK', {
            duration: 5000
          })
        }).catch(err => {
          console.log(err)
          this.snackBar.open(err.message, 'OK', {
            duration: 5000
          })
        })
      }
    })

  }
}
